import {FabricColor} from './FabricColor';
import {FabricCollection} from './FabricCollection';

export class Fabric {
  static ACTIVE = 'active';
  static INACTIVE = 'inactive';
  public id: number;
  public name: string;
  public dealerPrice: number;
  public customerPrice: number;
  public status: boolean;
  public position: number;
  public parentPosition: number;
  public overwriteCollectionPrice?: number;
  public fabricCollection: FabricCollection |number;
  public attachedColors: number;
  public fabricColors: FabricColor[] = [];

}
